import React, { useCallback, useEffect, useState } from "react";
import icon from "../../images/Icons/products.png";
import { useParams } from "react-router";
import useLogout from "../Auth/useLogout";
import axios from "axios";
import config from "../../config";
import NumberFormatter from "../../Component/NumberFormatter";
import { toast } from "react-toastify";
import NoData from "../../Component/NoData";
import Dataloader from "../../Component/Dataloader";

export default function TransporterEnquiryDetail() {
  const params = useParams();
  const logout = useLogout();
  const [loading, setLoading] = useState(false);
  const [dataLoading, setDataLoading] = useState(false);
  const [exist, setExist] = useState(true);
  const [data, setData] = useState({
    status: "",
    product: {
      brand: "",
      name: "",
      category: "",
      unique_id: "",
      min_price: "",
      max_price: "",
      price: "",
      origin_city: "",
      description: "",
      is_marked: 0,
    },
    billing: {
      address_line_one: "",
      address_line_two: "",
      city: "",
      state: "",
      pincode: "",
    },
    bidding: [],
  });
  const [price, setPrice] = useState("");
  const fetchData = useCallback(async () => {
    setDataLoading(true);
    try {
      const response = await axios.get(
        `${config.apiUrl}/transporter/product-enquiry/${params.id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: config.token,
            Accept: "application/json",
          },
        }
      );
      setData((prevData) => ({
        ...prevData,
        status: response.data.data.status,
        product: {
          brand: response.data.data.brand.name,
          name: response.data.data.commodity_product.name,
          category: response.data.data.commodity_product.category.name,
          unique_id: response.data.data.unique_id,
          min_price: response.data.data.min_price,
          max_price: response.data.data.max_price,
          price: response.data.data.price,
          origin_city: response.data.data.origin_city,
          description: response.data.data.description,
          is_marked: response.data.data.is_mark,
        },
        billing: {
          address_line_one: response.data.data.billing_address.address_line_one,
          address_line_two: response.data.data.billing_address.address_line_two,
          city: response.data.data.billing_address.state,
          state: response.data.data.billing_address.state,
          pincode: response.data.data.billing_address.pincode,
        },
        bidding: response.data.bidding_list,
      }));
      setPrice(response.data.data.price || "");
    } catch (error) {
      if (
        error.response &&
        (error.response.status === 404 ||
          error.response.status === 400 ||
          error.response.status === 500)
      ) {
        setExist(false);
      }
      if (error.response && error.response.status === 401) {
        logout();
      }
    } finally {
      setDataLoading(false);
    }
  }, [logout, params.id]);
  useEffect(() => {
    fetchData();
  }, [fetchData]);
  const priceSubmit = async (e) => {
    e.preventDefault();
    if (price) {
      setLoading(true);
      try {
        const response = await axios.post(
          `${config.apiUrl}/transporter/product-enquiry/${params.id}`,
          { price: price },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: config.token,
              Accept: "application/json",
            },
          }
        );
        toast.success(response.data.message, {
          position: "top-right",
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        const closeBtn = document.getElementById("priceClose");
        closeBtn.click();
        setPrice("");
      } catch (error) {
        toast.error(error.response.data.message, {
          position: "top-right",
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        if (error.response && error.response.status === 401) {
          logout();
        }
      } finally {
        setLoading(false);
      }
    } else {
      toast.error("Please enter price", {
        position: "top-right",
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  };

  return (
    <>
      <div className="page-content">
        <div className="container-fluid">
          <div className="row-layout mrb1">
            {dataLoading ? (
              <div className="d-flex justify-content-center">
                <Dataloader />
              </div>
            ) : (
              <>
                {exist ? (
                  <>
                    <div className="row-hd-txt">
                      <div className="row-hd-txt-left">
                        <img src={icon} alt="icon" />
                        <h5>Transporter Enquiry Details</h5>
                      </div>
                      <div className="status-right">
                        {data.product.is_marked === 1 ? (
                          <h6 className="status sent">Marked</h6>
                        ) : (
                          <h6 className="status sent">{data.status}</h6>
                        )}
                      </div>
                    </div>
                    <div className="row purchase-order-row">
                      <div className="col-lg-4 col-md-6 px-2">
                        <div className="purchase-order-table">
                          <label className="order-label">Product Details</label>
                          <table>
                            <tbody>
                              <tr>
                                <td>Quotation No:</td>
                                <td>{data.product.unique_id}</td>
                              </tr>
                              <tr>
                                <td>Category:</td>
                                <td>{data.product.category}</td>
                              </tr>
                              <tr>
                                <td>Product:</td>
                                <td>{data.product.name}</td>
                              </tr>
                              <tr>
                                <td>Brand:</td>
                                <td>{data.product.brand}</td>
                              </tr>
                              <tr>
                                <td>Min Price:</td>
                                <td>
                                  Rs{" "}
                                  <NumberFormatter
                                    number={data.product.min_price}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td>Max Price:</td>
                                <td>
                                  Rs{" "}
                                  <NumberFormatter
                                    number={data.product.max_price}
                                  />
                                </td>
                              </tr>
                              {data.product.price && (
                                <tr>
                                  <td>Your Price:</td>
                                  <td>
                                    Rs{" "}
                                    <NumberFormatter number={data.product.price} />
                                  </td>
                                </tr>
                              )}
                              <tr>
                                <td>Origin City:</td>
                                <td>{data.product.origin_city ?? "---"}</td>
                              </tr>
                              <tr>
                                <td>Description:</td>
                                <td>{data.product.description ?? "---"}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6 px-2">
                        <div className="purchase-order-table">
                          <label className="order-label">Buyer(Bill To)</label>
                          <table>
                            <tbody>
                              <tr>
                                <td>Address Line1:</td>
                                <td>{data.billing.address_line_one}</td>
                              </tr>
                              <tr>
                                <td>Address Line2:</td>
                                <td>{data.billing.address_line_two}</td>
                              </tr>
                              <tr>
                                <td>City:</td>
                                <td>{data.billing.city}</td>
                              </tr>
                              <tr>
                                <td>State:</td>
                                <td>{data.billing.state}</td>
                              </tr>
                              <tr>
                                <td>Pincode:</td>
                                <td>{data.billing.pincode}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <div className="col-lg-4 px-2">
                        <div className="purchase-order-table">
                          <div className="d-flex justify-content-between align-items-center mb-1">
                            <label className="order-label">Bidding List</label>
                            {!data.product.is_marked && (
                              <button
                                className="add-edit-btn"
                                data-bs-toggle="modal"
                                data-bs-target="#priceModal"
                              >
                                <i className="bi bi-currency-rupee"></i>Update
                                Price
                              </button>
                            )}
                          </div>
                          <div className="table-responsive">
                            <table className="table chart-table table-bordered">
                              <thead>
                                <tr>
                                  <th>#</th>
                                  <th>Transporter Name</th>
                                  <th>Given Price</th>
                                </tr>
                              </thead>
                              <tbody>
                                {data.bidding.length > 0 ? (
                                  data.bidding.map((bidding, index) => (
                                    <tr key={index}>
                                      <td className="fw-normal">{index + 1}</td>
                                      <td>{bidding.get_user.name}</td>
                                      <td>
                                        Rs{" "}
                                        <NumberFormatter
                                          number={bidding.price}
                                        />{" "}
                                      </td>
                                    </tr>
                                  ))
                                ) : (
                                  <tr>
                                    <td
                                      className="fw-normal text-center"
                                      colSpan={3}
                                    >
                                      No data found!
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  <NoData />
                )}
              </>
            )}
          </div>
        </div>
      </div>

      {/** Price Modal */}
      <div
        className="modal fade"
        id="priceModal"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-labelledby="priceModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-scrollable modal-dialog-centered">
          <div className="modal-content custom-modal">
            <div className="header">
              <h5 className="title">Update Transport Price</h5>
              <button
                type="button"
                className="custom-btn bg-warning rounded-2 text-dark"
                data-bs-dismiss="modal"
                aria-label="Close"
                id="priceClose"
              >
                Cancel
              </button>
            </div>
            <div className="body">
              <form onSubmit={priceSubmit}>
                <div className="row g-3">
                  <div className="col-lg-12">
                    <label htmlFor="price" className="form-label">
                      Price
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      value={price}
                      placeholder="Enter your price"
                      onChange={(e) => setPrice(e.target.value)}
                      onWheel={(e) => e.target.blur()}
                    />
                  </div>
                  <div className="col-lg-12 text-end">
                    <button
                      type="submit"
                      title="Update Profile"
                      className="submit_btn"
                      disabled={loading}
                    >
                      <i className="bi bi-floppy"></i>
                      {loading ? "Submitting" : "Submit"}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/**End Price Modal */}
    </>
  );
}
